import React, { useState } from "react";
import { useHistory } from "react-router";
import Sidebar from "../../partials/aside/Sidebar";
import validateFormPermisson from "../../../validtions/forms/permisson/add";
import httpService from "../../../services/httpServices/httpServices";

function AddPermission() {
  const [message, setMessage] = useState();
  const history = useHistory();

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const sendForm = async (e) => {
    e.preventDefault();
    const formData = getFormData();
    if (validateFormPermisson(formData) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormPermisson(formData),
        class_icon: "fa fa-exclamation-triangle",
      });

      return;
    }

    let resultRequest;
    try {
      resultRequest = await sendRuquest(formData);

      history.push("/permission/all");
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
    }
  };

  const getFormData = () => {
    const name = document.getElementById("name").value;
    const persianName = document.getElementById("name-persian").value;
    return {
      name: name,
      persian_name: persianName,
    };
  };

  const sendRuquest = async (formData) => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const resultRequest = await httpService.postRequest(
      process.env.REACT_APP_DOMAIN_API + "/v1/permission",
      formData,
      headersRequest
    );
    return resultRequest;
  };

  const validateForm = () => {};

  return (
    <>
      <Sidebar openItem="role-permission" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">دسترسی جدید</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <form onSubmit={sendForm}>
                <div className="form-group">
                  <label for="email">نام انگلیسی</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    tabIndex="1"
                  />
                </div>
                <div className="form-group">
                  <label for="pwd">نام فارسی</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name-persian"
                    tabIndex="2"
                  />
                </div>

                <button type="submit" className="btn btn-outline-primary">
                  ارسال
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AddPermission;
